import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';
import {
  faStar,
  faBullseye,
  faPen,
  faPuzzlePiece,
} from '@fortawesome/free-solid-svg-icons';
import DayStreakCard from './DayStreakCard';
import QuickActionItem from './QuickActionItem';
import LeaderboardWidget from './LeaderboardWidget';
import './styles/RightPanel.css';

const quickActions: {
  icon: ReactNode;
  label: string;
  route?: string;
  badge?: string;
  disabled?: boolean;
}[] = [
  {
    icon: <FontAwesomeIcon icon={faStar} />,
    label: 'Smart Quiz (AI)',
    route: '/dashboard/games/smart',
  },
  {
    icon: <FontAwesomeIcon icon={faBullseye} />,
    label: 'Geo Guess',
    route: '/dashboard/games/geo',
  },
  {
    icon: <FontAwesomeIcon icon={faPuzzlePiece} />,
    label: 'Sketcher',
    route: '/dashboard/games/sketcher',
  },
];

const leaderboardEntries = [];

const RightPanel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="right-panel">
      <button
        className="right-panel__create-btn"
        onClick={() => navigate('/dashboard/games')}
      >
        + Create Game
      </button>

      <DayStreakCard streak={14} />

      <div className="right-panel__section">
        <h4 className="right-panel__section-title">Quick Actions</h4>
        {quickActions.map((a) => {
          const route = a.route;
          return (
            <QuickActionItem
              key={a.label}
              icon={a.icon}
              label={a.label}
              onClick={route ? () => navigate(route) : undefined}
              badge={a.badge}
              disabled={a.disabled}
            />
          );
        })}
      </div>

      <LeaderboardWidget title="" entries={leaderboardEntries} />
    </div>
  );
};

export default RightPanel;
